import React from 'react';
import styled from 'styled-components';
import { colors } from 'helpers/ColorHelper';

import CtaPrimary from 'components/ui/CtaPrimary';

const StyledCtaPrimary = styled(CtaPrimary)`
  background-color: ${colors.LIGHT_BLUE_GREY};
  color: ${colors.ULTRAMARINE_BLUE};
  cursor: pointer;
`;

const PillButton = ({ type = 'button', ...rest }) => <StyledCtaPrimary type={type} {...rest} />;

export default PillButton;
